import React from "react";
import { Outlet } from "react-router-dom";
import { useTitle } from "../hooks/useTitle";
import { GameLayout } from "./GameLayout";
import { useGameVisit } from "./useGameVisit";

export default function GameSite() {
  useTitle("Games");
  useGameVisit();
  return (
    <GameLayout>
      <Outlet />
    </GameLayout>
  );
}
